import React from "react";
import "./Resume.css";

function Resume() {
  return (
    <div className="resume-page">

      {/* HEADER + BUTTON IN ONE ROW */}
      <div className="resume-header-row">

        <div className="resume-header-left">
          <h1>Abdulrahman Alamoudi</h1>

          <p className="resume-subtitle">
            Strategic Finance & M&A Analyst
          </p>

            <p className="resume-contact">
            Jeddah, Saudi Arabia | +966-54 686 8946 | 
            <a href="mailto:a.alhamid.a@gmail.com"> a.alhamid.a@gmail.com </a> | 
            <a
                href="https://abdulrahmanalamoudi.netlify.app"
                target="_blank"
                rel="noreferrer"
            >
                abdulrahmanalamoudi.netlify.app
            </a>
            </p>
        </div>

        <a
          className="resume-download-btn"
          href="/assets/Abdulrahman_Alamoudi_Resume.pdf"
          target="_blank"
          rel="noreferrer"
        >
          Download Resume (PDF)
        </a>

      </div>

      <hr />

      {/* The rest of your resume stays the same */}


      <h2>Professional Summary</h2>
      <p>
        Finance professional with a strong foundation in corporate finance, financial modelling,
        business valuation, and strategic financial analysis. Exposure to global financial
        institutions through professional training and job simulations, including PwC, Citi, and
        JPMorgan, has strengthened commercial awareness, analytical rigour, and attention to detail.
        Recognised for analytical thinking, adaptability, and a results-driven approach, with a
        commitment to delivering meaningful value through high-quality financial analysis and
        informed decision-making.
      </p>

      <h2>Areas of Expertise</h2>
      <p>
        Strategic Finance | Corporate Finance | Financial Modelling | Business Valuation | M&A Screening & Analysis |
        FP&A | Investment Analysis | Financial Statement Analysis | Budgeting & Forecasting | Industry & Market Research
      </p>


      <h2>Skills</h2>

      <h3>Technical Skills</h3>
      <ul>
        <li>Advanced Microsoft Excel</li>
        <li>Microsoft Power BI</li>
        <li>Python</li>
        <li>Microsoft PowerPoint</li>
        <li>Data Analytics & Visualisation</li>
      </ul>

      <h3>Soft Skills</h3>
      <ul>
        <li>Analytical Thinking</li>
        <li>Problem Solving</li>
        <li>Communication</li>
        <li>Adaptability</li>
        <li>Attention to Detail</li>
      </ul>

      <h3>Professional Certifications</h3>
      <ul>
        <li>
          Regulatory Framework for Valuation Profession and International Valuation Standards,
          Module 001, Saudi Authority for Accredited Valuers (TAQEEM), Jul 2026
        </li>
        <li>Bloomberg Market Concepts (BMC), Bloomberg, Nov 2020</li>
        <li>Financial Markets with Honors, Yale University, Mar 2023</li>
        <li>
          Data Analysis and Presentation Skills: The PwC Approach Specialization, PwC, May 2023
        </li>
        <li>
          Investment and Portfolio Management Specialization, Rice University, Jan 2024
        </li>
      </ul>

      <h2>Experience</h2>

      <h3>WADAQ – Jeddah, Saudi Arabia</h3>
      <p><strong>Business Development Lead, Consulting and Business Transformation</strong></p>
      <p>Oct 2023 – Dec 2025</p>
      <ul>
        <li>Optimized MultiSoft usage and trained staff to improve reporting efficiency.</li>
        <li>Built a 2023 performance dashboard to track KPIs and support decision-making.</li>
        <li>Managed two strategic projects from concept to delivery.</li>
        <li>Conducted feasibility studies and M&A screening for acquisition targets.</li>
        <li>Led negotiations and provided strategic support across Business Development, HR, and Marketing.</li>
      </ul>

      <h3>Capital Transport Co. – Jeddah, Saudi Arabia</h3>
      <p><strong>Analysis Consultant – Internship</strong></p>
      <p>Jan 2022 – Mar 2022</p>
      <ul>
        <li>Reviewed expansion plans and developed strategic recommendations.</li>
        <li>Produced a 10-page analysis report with actionable insights.</li>
        <li>Presented findings to leadership; several recommendations were implemented.</li>
        <li>Built an Excel dashboard to track expansion progress and performance.</li>
      </ul>

      <h3>KPMG, Australia – Virtual Internship</h3>
      <p><strong>Data Analytics Consulting</strong></p>
      <p>Jul 2021 – Dec 2021</p>
      <ul>
        <li>Completed a customer-targeting project with the Data & Analytics team.</li>
        <li>Assessed data quality, segmented customers, and identified high-value groups.</li>
        <li>Built dashboards and delivered data-driven recommendations to stakeholders.</li>
      </ul>

      <h2>Professional Training & Job Simulations</h2>
      <ul>
        <li>Citi – Investment Banking</li>
        <li>Citi – Finance</li>
        <li>KPMG – Audit & Assurance</li>
        <li>JPMorgan – Investment Banking</li>
      </ul>

      <h2>Education</h2>

      <h3>Taylor's University, Malaysia</h3>
      <p><strong>Bachelor of Business (Honours) in Banking & Finance</strong></p>
      <p>Aug 2019 – Mar 2023</p>
      <p>
        Second Class Upper Honours | Degree accredited by the University of the West of England (UWE Bristol).
      </p>
      <p>
        <strong>Relevant Coursework:</strong> Corporate Finance, Financial Markets, Portfolio Management,
        Risk Management, Derivatives, Wealth Management, Islamic Banking & Finance, FinTech & Innovation,
        Blockchain Economics, Quantitative Methods, Microeconomics and Macroeconomics.
      </p>
      <p>
        <strong>Selected Academic Projects:</strong> Bank Simpanan Nasional Financial Analysis Report (2020),
        Interest Rate Impact Study (2021), Political Events and Financial Market Analysis (2022),
        Research Methods & Final Year Research Project.
      </p>
      <p>
        <strong>Achievements & Activities:</strong> Dean's List (Sep 2020), First Place – TBSS Business Case Competition (Aug 2019),
        Participated in Bloomberg, Maybank & Silverlake events, Member – French Club Society,
        Advocate for sustainability initiatives.
      </p>

    </div>
  );
}

export default Resume;
